import { ButtonGroup, PrimaryButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { RegistrationStatus } from "../infrastructure/redux/org/org-actions";
import { ReduxState } from "../infrastructure/redux/state";
import Translated from "../infrastructure/Translated";
import { useRootPath } from "../infrastructure/useRootPath";

const ManuellFlowConfirmationSignering: FC = () => {
  const rootPath = useRootPath();
  const registrationStatus = useSelector(
    (state: ReduxState) => state.org.registrationStatus,
  );

  // Guard for tilfeldig navigering
  useEffect(() => {
    if (registrationStatus !== RegistrationStatus.COMPLETE) {
      window.location.href = `${rootPath}/bedrift`;
    }
  }, [registrationStatus]);

  return (
    <main>
      <Heading level={1} size="large">
        <Translated textKey="register.org.manual.form.submitted.heading" />
      </Heading>

      <p>
        <Translated textKey="register.org.manual.form.submitted.text" />
      </p>
      <p>
        <Translated textKey="generic.have_a_nice_day" />
      </p>

      <ButtonGroup>
        <PrimaryButton as="a" href="https://signering.posten.no/">
          <Translated textKey="generic.back_to_front_page" />
        </PrimaryButton>
      </ButtonGroup>
    </main>
  );
};

export default ManuellFlowConfirmationSignering;
